import { useResources, useRouteMatch } from '@funtech-int/rival-react';
import { useAuthManager } from '@funtech-int/yango-shared';

import { useGraphqlClient } from '@/shared/hooks/useGraphqlClient';

import { filmRoute } from '../routes';
import { movieWebPageResourceQuery } from '../lib/movieWebPageResource';

import { movieCardResourceQuery } from './useMovieCard';

export function useMoviePage() {
    const location = useRouteMatch(filmRoute);
    const contentId = location.params.id;

    const client = useGraphqlClient();
    const { isAuthorized } = useAuthManager();

    const [movie, movieWebPage] = useResources(
        movieCardResourceQuery({
            client,
            variables: {
                contentId,
                isAuthorized,
            },
        }),
        movieWebPageResourceQuery({
            client,
            variables: {
                contentId,
            },
        })
    );

    return { contentId, movie, movieWebPage };
}
